import React,{useRef} from 'react';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import download from '../../../Assets/images/download.png'
import Receipt from './Receipt';
import './receipt.css'
import { trackEvent } from '../../../mixpanel';
import { jwtDecode } from "jwt-decode";





const App1 = ({receipt,type}) => {
  const token = sessionStorage.getItem("token");
  const decode = jwtDecode(token)
  if(type ==="repayment"){
    trackEvent("Receipt Download", {
      userId: decode?.userId,
      action: `Receipt clicked, Receipt_${receipt?.firstname}_${receipt?.addedOn}.pdf`,
    })
  }
  const company = {
  name: type==="repayment"?"MONK CAPITAL PVT LTD":"Feepay",
  address: `The Platina, B-406, Gachibowli, Hyderabad, Telangana, India, 500032`
};

  let user={}
  let receiptNo=''
  let date=''
  let fileName=''
  switch (type) {
    case "feepayment":   user = {
                          username: receipt.firstname, // Example username
                          LoanID: receipt.txnid, // Example LoanID
                          loanType:receipt.payment_name ,
                          amount:parseInt(receipt?.paymentAmount),
                          paymentMethod: receipt.mode,
                          bank:receipt.bankName?receipt?.bankName:"NA",
                          branch: receipt?.bankBranch?receipt?.bankBranch:"NA",
                          amountInWords: receipt.paymentAmount,
                          dateOfPayment: receipt.addedOn, // Example date of payment
                        };

                          receiptNo = receipt.txnid;
                          date = receipt.addedOn;
                          fileName = `Receipt_${receipt.firstname}_${date}.pdf`;
      
      break;
    case "repayment": user = {
                          username: sessionStorage.getItem("name"),
                          emiAmount:receipt?.paymentAmount,
                          // penalty:receipt?.paidOverdue,
                          // bounceCharges:receipt?.paidBounceCharges?Math.round(receipt?.paidBounceCharges - (receipt?.paidBounceCharges - (receipt?.paidBounceCharges/1.18))):0,
                          // bounceChargesGST:receipt?.paidBounceCharges?Math.round(receipt?.paidBounceCharges - (receipt?.paidBounceCharges/1.18)):0, // Example username
                          amount:receipt?.paymentAmount,
                          amountInWords: receipt?.paymentAmount,
                          emiNo:receipt?.emiNo,
                          dateOfPayment: receipt?.paidAt 
                          ? new Date(receipt.paidAt).toLocaleDateString("en-GB") 
                          : null, 
                        };

                          receiptNo = sessionStorage.getItem("LegacyLoanId");
                         
                          fileName = `Receipt_${sessionStorage.getItem("name")}.pdf`;
      
      break;
   
  
    default: user = {};
      break;
  }
 
  // const handleCloseTab=()=>{
  //   document.getElementById('pdfpage').className="clicked"
  //   setTimeout(() => {
  //     window.close()
      
  //   }, 2000);
  // }
  
  return(
  <>
    <PDFDownloadLink document={<Receipt company={company} user={user} receiptNo={receiptNo} date={date} />} fileName={fileName}>
    {type==="feepayment"?<span>Receipt</span>:<></>}<img style={{width:'20px',marginLeft:'5px',marginTop:'-2rem'}} src={download}/>
    </PDFDownloadLink>
  </>
  )

}




export default App1;
